/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum OthersFeatureFlags {
    othr_2603_b_handler_hpa_scaling_129247 = 'othr_2603_b_handler_hpa_scaling_129247',
    othr_2603_b_handler_hpa_custom_metric_129247 = 'othr_2603_b_handler_hpa_custom_metric_129247',
    othr_2603_b_orphaned_job_waiting_recovery_129247 = 'othr_2603_b_orphaned_job_waiting_recovery_129247'
}
